import { Controller } from "@hotwired/stimulus"
import { Turbo } from "@hotwired/turbo-rails"
import Choices from "choices.js";

// Connects to data-controller="performances--filter"
export default class extends Controller {
  static targets = ["form", "workerSelect", "monthField"]

  connect() {
    this.choices = new Choices(this.workerSelectTarget, {
      shouldSort: false,
      itemSelectText: '',
      noResultsText: '見つかりません'
    });
  }

  preventEnter(event) {
    if (event.key === "Enter") {
      event.preventDefault()
    }
  }

  submitForm() {
    this.element.requestSubmit()
  }

  reset(e) {
    e.preventDefault()
    confirm("作業スケジュールで登録した予定を読み込みますか？")
    const url = new URL("/performances", window.location.origin)
    Turbo.visit(url)
  }

  loadSchedule(event) {
    event.preventDefault()

    if (!this.workerSelectTarget.value) {
      alert("作業者を選択してください")
      return
    }

    if (!this.workerSelectTarget.value) {
      alert("先に職員を選択してください。")
      return
    }

    if (!confirm("作業スケジュールで登録した予定を読み込みますか？")) {
      return
    }

    const form = this.formTarget
    form.requestSubmit()
  }
}
